import React from 'react';
import CircleHalf from '@mui/icons-material/BrightnessMediumRounded';
import Moon from '@mui/icons-material/DarkModeRounded';
import Sun from '@mui/icons-material/WbSunnyRounded';
import {useTheme} from "../context/ThemeContext";

const ThemeToggle = () => {
  const {theme, toggleTheme} = useTheme();

  const getIcon = () => {
    switch (theme) {
      case 'light':
        return <Sun size={18}/>;
      case 'dark':
        return <Moon size={18}/>;
      case 'auto':
        return <CircleHalf size={18}/>;
      default:
        return <Sun size={18}/>;
    }
  };

  const getTitle = () => {
    switch (theme) {
      case 'light':
        return 'Switch to dark theme';
      case 'dark':
        return 'Switch to auto theme';
      case 'auto':
        return 'Switch to light theme';
      default:
        return 'Toggle theme';
    }
  };

  return (
    <a
      onClick={toggleTheme}
      title={getTitle()}
      aria-label={getTitle()}
    >
      {getIcon()}
    </a>
  );
};

export default ThemeToggle;